export default __webpack_public_path__ + "static/homepage-merch-ee1695acba09c16daad5a011a32b3a82.png";